<template>
  <div class="record">
    <div class="inner">
      <div class="nav">
        <div class="record_type">
          <div
            :class="index === subindex ? 'active' : 'inactive'"
            v-for="(item, index) in tabtit"
            :key="index"
            @click="handleClick(index)"
          >
            {{ item }}
          </div>
        </div>
        <div v-if="clientWidth > 900">
          <el-date-picker
            v-model="value"
            type="daterange"
            range-separator="to"
            start-placeholder="startTime"
            end-placeholder="endTime"
          >
          </el-date-picker>
          <el-button type="primary" style="border-radius: 20px">{{
            $t("搜索")
          }}</el-button>
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%; margin: 30px 0"
        v-show="subindex === 0"
        :empty-text="$t('暫無數據')"
        @row-click="showItem"
      >
        <el-table-column prop="record_num" :label="$t('訂單編號')">
        </el-table-column>
        <el-table-column :label="$t('狀態')">
          <template slot-scope="{ row }">
            <span v-if="row.status === 0">{{ $t("已删除") }}</span>
            <span v-else-if="row.status === 1">{{ $t("新建") }}</span>
            <span v-else-if="row.status === 2">{{ $t("支付中") }}</span>
            <span v-else-if="row.status === 3">{{ $t("已支付") }}</span>
            <span v-else-if="row.status === 4">{{ $t("已取消") }}</span>
            <span v-else>{{ $t("交易失敗") }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="product_name" :label="this.$t('商品')">
        </el-table-column>
        <el-table-column :label="this.$t('價格')">
          <template slot-scope="{ row }">
            <span>{{ originPriceFormat(row.price) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('登錄日')">
          <template slot-scope="{ row }">
            <span>{{ row.create_at.substring(0, 19) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        :data="tableData"
        style="width: 100%; margin: 30px 0"
        v-show="subindex === 1"
        :empty-text="$t('暫無數據')"
      >
        <el-table-column prop="record_num" :label="$t('使用點數')">
          <template slot-scope="{ row }">
            <span>{{ originPriceFormat(row.point) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('當前點數')">
          <template slot-scope="{ row }">
            <span>{{ originPriceFormat(row.current_point) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="product_name" :label="this.$t('商品名')">
        </el-table-column>
        <el-table-column :label="this.$t('登錄日')">
          <template slot-scope="{ row }">
            <span>{{ row.create_at.substring(0, 19) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="total" :page="page" @repeater="repeater" />
      <Dialog
        v-if="show"
        width="25%"
        :title="$t('儲值記錄')"
        :cancelText="$t('取消')"
        :submitText="$t('確認')"
        @cancel="cancel"
        @submit="cancel"
      >
        <div class="record-detail">
          <div class="detail-item">
            <div class="detail-label">{{ $t("訂單編號") }}:</div>
            <div :title="showingItem.record_num">
              {{ showingItem.record_num }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">{{ $t("狀態") }}:</div>
            <div :title="showingItem.status">{{ showingItem.status }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">{{ $t("商品") }}:</div>
            <div :title="showingItem.product_name">
              {{ showingItem.product_name }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">{{ $t("價格") }}:</div>
            <div :title="showingItem.priceFormated">
              {{ showingItem.priceFormated }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">{{ $t("登錄日") }}:</div>
            <div :title="showingItem.create_at">
              {{ showingItem.create_at }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">{{ $t("當前點數：") }}</div>
            <div :title="showingItem.current_point">
              {{
                showingItem.status == RECHARGE_STATUS[3]
                  ? originPriceFormat(showingItem.current_point)
                  : "-"
              }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">{{ $t("支付途徑") }}:</div>
            <div :title="showingItem.payment_method">
              {{ showingItem.payment_method }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">
              {{ $t("交易號") }}:{{ showingItem.payment_method }}
            </div>
            <div :title="showingItem.trade_seq">
              {{ showingItem.trade_seq }}
            </div>
          </div>
          <div class="detail-item" v-if="showingItem.vbank">
            <div class="detail-label">{{ $t("银行：") }}</div>
            <div :title="showingItem.error_message">
              {{ showingItem.vbank }}
            </div>
          </div>
          <div class="detail-item" v-if="showingItem.vaccount">
            <div class="detail-label">{{ $t("虚拟账号：") }}</div>
            <div :title="showingItem.error_message">
              {{ showingItem.vaccount }}
            </div>
          </div>
          <div class="detail-item" v-if="showingItem.deadline">
            <div class="detail-label">{{ $t("过期日期：") }}</div>
            <div :title="showingItem.error_message">
              {{
                showingItem.deadline.replace(
                  /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/,
                  "$1-$2-$3 $4:$5:$6"
                )
              }}
            </div>
          </div>
          <div
            class="detail-item"
            v-if="
              (showingItem.status == RECHARGE_STATUS[5] ||
                showingItem.status == RECHARGE_STATUS[4]) &&
              showingItem.error_message
            "
          >
            <div class="detail-label">{{ $router.lang.get("错误信息：") }}</div>
            <div :title="showingItem.error_message">
              {{ showingItem.error_message }}
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  </div>
</template>
<script>
import filters from "@/utils/filters";
import { rechargeRecord, propRecord, getRechargeDetail } from "@/api/mall";
import cookie from "js-cookie";
import enums from "@/utils/enums";
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      tabtit: [this.$t("儲值記錄"), this.$t("消費記錄")],
      subindex: 0,
      value: [],
      total: 0,
      tableData: [],
      page: 1,
      show: false,
      showingItem: {},
      refCounting: 0,
      RECHARGE_STATUS: enums.RECHARGE_STATUS,
    };
  },
  computed: {
    ...mapState({
      clientWidth: (state) => state.screen.clientWidth,
      currentTpye: (state) => state.header.currentTpye,
    }),
  },
  watch: {
    currentTpye(newval) {
      console.log(newval);
    },
  },
  created() {
    this.getData();
    if (cookie.get("userInfo")) {
      if (this.$route.query.id) {
        this.$store.dispatch("getUser");
        // this.showDetail(this.$route.query.id);
      }
    }
  },
  methods: {
    cancel() {
      this.show = false;
    },
    async showItem(row) {
      this.showingItem = { ...row };
      const res = await getRechargeDetail({ id: row.id });
      this.showingItem = { ...res.data.results[0] };
      this.showingItem.priceFormated =
        "฿" + filters.priceFormat(this.showingItem.price);
      this.showingItem.create_at = moment(this.showingItem.create_at).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.showingItem.status = enums.RECHARGE_STATUS[this.showingItem.status];
      this.show = true;
    },
    async showDetail(id) {
      let _this = this;
      const res = await getRechargeDetail({ id: id });
      _this.showingItem = { ...res.data.results[0] };
      _this.showingItem.priceFormated =
        "฿" + filters.priceFormat(_this.showingItem.price);
      this.showingItem.create_at = moment(this.showingItem.create_at).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.show = true;
      _this.showingItem.status =
        enums.RECHARGE_STATUS[_this.showingItem.status];
    },
    originPriceFormat: filters.priceFormat,
    handleClick(index) {
      this.subindex = index;
      this.page = 1;
      this.getData();
    },
    async getData() {
      if (this.subindex === 0) {
        const res = await rechargeRecord({ page: this.page, limit: 10 });
        this.total = res.data.paging.total;
        this.tableData = res.data.results;
      } else if (this.subindex === 1) {
        const res = await propRecord({ page: this.page, limit: 10 });
        this.total = res.data.paging.total;
        this.tableData = res.data.results;
      }
    },
    repeater(page) {
      this.page = page;
      this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
.record {
  .inner {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
    @media only screen and (max-width: 900px) {
      width: 100%;
    }
    .nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .record_type {
        display: flex;
        align-items: center;
        .inactive {
          margin-right: 20px;
          line-height: 30px;
          min-width: 120px;
          padding: 0 5px;
          height: 30px;
          font-size: 14px;
          border-radius: 15px;
          text-align: center;
          border: 1px solid #a4a4a4;
          cursor: pointer;
          @media only screen and (max-width: 900px) {
            margin-right: 20px;
            line-height: 30px;
            min-width: 80px;
            padding: 0 5px;
            height: 30px;
            font-size: 14px;
            border-radius: 15px;
          }
        }
        .active {
          margin-right: 20px;
          line-height: 30px;
          min-width: 120px;
          height: 30px;
          font-size: 14px;
          border-radius: 15px;
          text-align: center;
          border: 1px solid transparent;
          background: #c6a86c;
          padding: 0 5px;
          color: #fff;
          cursor: pointer;
          @media only screen and (max-width: 900px) {
            margin-right: 20px;
            line-height: 30px;
            min-width: 80px;
            padding: 0 5px;
            height: 30px;
            font-size: 14px;
            border-radius: 15px;
          }
        }
      }
      ::v-deep .el-date-editor {
        border-radius: 20px;
        margin-right: 20px;
      }
    }
  }
}
::v-deep .el-table {
  background-color: transparent;
  th {
    background-color: #e7eaf0;
    color: #939393;
    font-size: 16px;
    font-weight: 200;
    @media only screen and (max-width: 900px) {
      font-size: 14px;
      padding: 6px 0;
    }
    .cell {
      font-weight: 200;
      @media only screen and (max-width: 900px) {
        // padding-left: 5px;
        // padding-right: 5px;
        line-height: 16px;
      }
    }
  }
  tr {
    background-color: transparent;
  }
}
::v-deep .el-table__empty-block {
  @media only screen and (max-width: 900px) {
    min-height: 60px;
  }
}
.record-detail {
  margin: 35px 0;
  line-height: 32px;
}

.detail-collapse {
  font-size: 3vw;
}

.record-detail > div:last-child {
  word-break: normal;
}

.detail-item {
  display: flex;
}

.detail-item > div:nth-child(2) {
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.detail-label {
  width: 30%;
}

.detail-counting {
  margin: 20px 0;
  font-size: 14px;
  text-align: center;
}

.detail-counting > div:nth-child(2) {
  font-size: 20px;
  color: #595959;
}
</style>
